import {
  type Address,
  checksumAddress,
  getAddress,
  isAddress,
  isAddressEqual,
  zeroAddress
} from 'viem'

export function isZeroAddress(address: Address): boolean {
  return isAddressEqual(address, zeroAddress)
}

/** Plural `getAddress`: checksum-normalize a list of addresses. */
export function getAddresses(addresses: readonly string[]): Address[] {
  return addresses.map(address => getAddress(address))
}

export function isNonZeroAddress(address: Address): boolean {
  return !isAddressEqual(address, zeroAddress)
}

export function abbreviateAddress(address: string | Address, segLength = 4) {
  if (!address) return ''
  if (isAddress(address)) address = checksumAddress(address)
  const firstSegment = address.substring(0, segLength + 2)
  const lastSegment = address.substring(address.length, address.length - segLength)
  return `${firstSegment}...${lastSegment}`
}
